import React from "react";
import { styled } from "@mui/material";
import { ReactComponent as CheckCircleIcon } from "../assets/patientCard/checkCircleIcon.svg";

const ValidateTextStyled = styled("div")({
  display: "flex",
  gap: 6,
  marginBottom: 6,
  alignItems: "center",
  color: "green",
  fontSize: 13,
  "& svg": { fill: "currentcolor", width: 16, height: 16 },
});

interface ValidatedIndicatorProps {
  text?: string;
}

export const ValidatedIndicator = ({ text }: ValidatedIndicatorProps) => {
  return (
    <ValidateTextStyled>
      <CheckCircleIcon /> {text || "Clinically validated"}
    </ValidateTextStyled>
  );
};
